
import axios from 'axios';


let actucontroller ;
export const  axios_calendar_geteventsbyclientid= async ({email, id})=>{
    actucontroller && actucontroller.abort() ;
    const controller = new AbortController();
    actucontroller = controller ;
    return await   axios.post('/calendar/geteventsbyclientid',{email,id},{signal: controller.signal},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}

export const  axios_calendar_updaterdv = async (rdv)=>{
    return await   axios.post('/calendar/updaterdv',{...rdv},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}

export const  axios_calendar_recordrdv = async (rdv)=>{
    return await   axios.post('/calendar/recordrdv',{...rdv},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}

export const  axios_calendar_getrdvs= async (email)=>{
    return await   axios.post('/calendar/getrdvs',{email},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}})
}
